import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BB from './images/BB.png';
import Map from './images/Map.png';
import Header from './Component/Header';
import Building2 from './images/Building2.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons';
import GrayBuilding from './images/GrayBuilding.png';
import Contact from './images/Contact.png';
import Buildingimage from './images/Buildingimage.png';
import ArrowLeft from './images/ArrowLeft.png';

const ViewProject = () => {
  // First, initialize all hooks and state variables
  const location = useLocation(); 
  const navigate = useNavigate();
  
  // Then extract projectId from location state
  const { projectId, project, blocksData } = location.state || {};
  
  console.log("Project ID from location:", projectId);
  console.log("Blocks Data from location:", blocksData);
  console.log("Project from location:", project);
  
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [projectImage, setProjectImage] = useState([]);
      const [customerData, setCustomerData] = useState(null); 
const [showStageDropdown, setShowStageDropdown] = useState(false);
const [showProjectTypeDropdown, setShowProjectTypeDropdown] = useState(false);
const [showImagePreview, setShowImagePreview] = useState(false);
const [stages, setStages] = useState([]);


  const fileInputRef = useRef(null);


  
  const [projectData, setProjectData] = useState({
    projectName: '',
    projectStage: '',
    siteAddress: '',
    numFloors: '',
    numBlocks: '1',
    numFlatsPerFloor: '',
  project_type: '', 
     builderName: '',
    builderContactNo: '',
    siteContactName: '',
    siteContactNo: '',
  });

  useEffect(() => {
    setProjectImage(projectImage);
  }, []);

      useEffect(() => {
        if (project && project.customerId) {
            getCustomerDetails(project.customerId);
        } else {
            console.error("No customer ID available");
        }
    }, [project]);

    useEffect(() => {
        const userData = JSON.parse(sessionStorage.getItem('userData'));
        const customerId = userData?._id; // Assuming _id is the customer ID
        if (customerId) {
            getCustomerDetails(customerId);
        } else {
            console.error("No customer ID available in session storage");
            setError("No customer ID available");
        }
    }, []);

    useEffect(() => {
  const fetchStages = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(
        process.env.REACT_APP_FORE_APILINK + "/projects/get-stage-of-construction",
        { headers: { "x-token": token } }
      );
      const data = await res.json();
      if (data.success) {
        // Map array of strings into { value, label } objects
        const formattedStages = data.data.map(stage => ({
          value: stage,
          label: stage
        }));
        setStages(formattedStages);
      }
    } catch (err) {
      console.error("Error fetching stages:", err);
    }
  };

  fetchStages();
}, []);


  // Set project data from location state
  useEffect(() => {
    if (project) {
      setProjectData({
        projectName: project.projectName || '',
        projectStage: project.stageofconstruction || '',
        siteAddress: project.siteAddress || '',
        numFloors: project.numFloors || '',
        numBlocks: project.numBlocks || '1',
        numFlatsPerFloor: project.numFlatsPerFloor || '',
      project_type: project.project_type || '',
        builderName: project.builderName || '',
       builderContactNo: project.builderContactNo || '',
      siteContactName: project.siteContactName || '',
      siteContactNo: project.siteContactNo || ''
        
      });

      // Set project image
      if (project.projectImage && project.projectImage.length > 0) {
        const imagePath = project.projectImage[0];
        if (imagePath.startsWith('http')) {
          setProjectImage(imagePath);
        } else {
          const fullImageUrl = `${process.env.REACT_APP_FORE_MEASURIT_UIIMAGEURL}${imagePath}`;
          setProjectImage(fullImageUrl);
        }
      }
      setLoading(false);
    }
  }, [project]);

  // Set blocks data
  useEffect(() => {
    if (blocksData && blocksData.length > 0) {
      const block = blocksData[0]; // Get first block
      
      setProjectData(prev => ({
        ...prev,
        numFloors: block.numFloors ? block.numFloors.toString() : prev.numFloors,
        numFlatsPerFloor: block.numFlatsPerFloor ? block.numFlatsPerFloor.toString() : prev.numFlatsPerFloor,
        numBlocks: blocksData.length.toString()
      }));
    }
  }, [blocksData]);

  // Fetch project data when component mounts
  useEffect(() => {
    console.log("Project ID from location state:", projectId);
    if (projectId && !project) {
      fetchProjectData();
    } else if (!projectId && !project) {
      setError("No project ID provided");
      setLoading(false);
    }
  }, [projectId, project]);

  const fetchProjectData = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem('token');
      
      if (!token) {
        console.error("No token found");
        setError('Authentication token not found. Please login again.');
        setLoading(false);
        return;
      }

      // Log the API URL for debugging
      const apiUrl = `${process.env.REACT_APP_FORE_APILINK}/projects/get-project?projectId=${projectId}`;
      console.log("Fetching from URL:", apiUrl);
      
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });

      // Log response status
      console.log("Response status:", response.status);
      
      // Get the response data
      const data = await response.json();
      console.log("Response data:", data);
      
      if (!response.ok) {
        throw new Error(data.error || data.message || 'Failed to fetch project data');
      }

      // Update state with fetched project data
      setProjectData({
        projectName: data.projectName || '',
        projectStage: data.stageofconstruction || '',
        siteAddress: data.siteAddress || '',
        numFloors: data.numFloors || '',
        numBlocks: data.numBlocks || '1',
        numFlatsPerFloor: data.numFlatsPerFloor || '',
        project_type: data.project_type || '',
        builderName: data.builderName || '',
        builderContactNo: data.builderContactNo || '',
        siteContactName: data.siteContactName || '',
        siteContactNo: data.siteContactNo || ''

      });

      console.log("Updated project data state:", {
        projectName: data.projectName || '',
        projectStage: data.stageofconstruction || '',
        siteAddress: data.siteAddress || '',
        numFloors: data.numFloors || '',
        numBlocks: data.numBlocks || '',
        numFlatsPerFloor: data.numFlatsPerFloor || ''
      });

      if (data.projectImage && data.projectImage.length > 0) {
        // Assuming the first image is the main project image
        const imagePath = data.projectImage[0];
        console.log("Project image path:", imagePath);
        
        if (data.projectImage && data.projectImage.length > 0) {
          // Assuming the first image is the main project image
          const imagePath = data.projectImage[0];
          console.log("Project image path:", imagePath);
          
          // Check if the path is a full URL or a relative path
          if (imagePath.startsWith('http')) {
            console.log("Using image path as is:", imagePath);
            setProjectImage(imagePath);
          } else {
            // Construct the full URL based on your API base URL
            const fullImageUrl = `${process.env.REACT_APP_FORE_MEASURIT_UIIMAGEURL}${imagePath}`;
            console.log("Constructed full image URL:", fullImageUrl);
            setProjectImage(fullImageUrl);
          }
        } else {
          console.log("No project image found, using default");
          setProjectImage(''); // Set to default image
        }
      }

      setLoading(false);
    } catch (error) {
      console.error('Error fetching project data:', error);
      setError(error.message || 'Failed to fetch project data');
      setLoading(false);
    }
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProjectData({
      ...projectData,
      [name]: value
    });
  };

  useEffect(() => {
    // Set default value for numBlocks if it's empty
    if (!projectData.numBlocks) {
      setProjectData(prev => ({
        ...prev,
        numBlocks: '1'
      }));
    }
  }, []);

  // Function to create a new block
  const createBlock = async (token) => {
    try {
      // Validate required fields
      if (!projectId) {
        console.error("Missing project ID");
        throw new Error("Project ID is required");
      }
      
      // Validate numFloors
      if (!projectData.numFloors || projectData.numFloors.trim() === '') {
        console.error("Missing number of floors");
        throw new Error("Number of floors is required");
      }
      
      const numFloors = parseInt(projectData.numFloors);
      if (isNaN(numFloors) || numFloors <= 0) {
        console.error("Invalid number of floors:", projectData.numFloors);
        throw new Error("Number of floors must be a positive number");
      }
      
      // Validate numFlatsPerFloor
      if (!projectData.numFlatsPerFloor || projectData.numFlatsPerFloor.trim() === '') {
        console.error("Missing number of flats per floor");
        throw new Error("Number of flats per floor is required");
      }
      
      const numFlatsPerFloor = parseInt(projectData.numFlatsPerFloor);
      if (isNaN(numFlatsPerFloor) || numFlatsPerFloor <= 0) {
        console.error("Invalid number of flats per floor:", projectData.numFlatsPerFloor);
        throw new Error("Number of flats per floor must be a positive number");
      }
      
      // Calculate total flats
      const numFlats = numFloors * numFlatsPerFloor;
      
      // Create block data with validated values
      const blockData = {
        projectId: projectId,
        blockNo: `1`, // Default name for the first block
        numFloors: numFloors,
        numFlatsPerFloor: numFlatsPerFloor,
        numFlats: numFlats,
        is_active: true
      };
  
      console.log("Creating new block:", blockData);
  
      // Use the createNewBlock endpoint from the backend
      const blockApiUrl = `${process.env.REACT_APP_FORE_APILINK}/blocks/create-new-block`;
      
      const blockResponse = await fetch(blockApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify(blockData)
      });
  
      const blockResponseData = await blockResponse.json();
      
      if (!blockResponse.ok) {
        throw new Error(blockResponseData.error || blockResponseData.message || 'Failed to create new block');
      }
      
      console.log("Block created successfully:", blockResponseData);
      return blockResponseData;
    } catch (error) {
      console.error('Error creating block:', error);
      throw error;
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      const token = sessionStorage.getItem('token');
      
      if (!token) {
        setError('Authentication token not found. Please login again.');
        setIsSaving(false);
        return;
      }
  
      console.log("Submitting updated project data:", projectData);
  
      // Step 1: Create a copy of project data without numBlocks
      // This prevents the backend from auto-creating empty blocks
      const projectDataForUpdate = { ...projectData };
      const numBlocksValue = projectDataForUpdate.numBlocks; // Save for later
      delete projectDataForUpdate.numBlocks; // Remove numBlocks from the update

      const backendProjectData = {
      projectName: projectDataForUpdate.projectName,
      stageofconstruction: projectDataForUpdate.projectStage,
      siteAddress: projectDataForUpdate.siteAddress,
      numFloors: projectDataForUpdate.numFloors,
      numFlatsPerFloor: projectDataForUpdate.numFlatsPerFloor,
 project_type: projectDataForUpdate.projectType,
   builderName: projectDataForUpdate.builderName || customerData?.customer_name || '',
  builderContactNo: projectDataForUpdate.builderContactNo || customerData?.mobile_number || '',
      // Map secondary contact fields to site contact fields
      siteContactName: projectDataForUpdate.secondaryName || projectDataForUpdate.siteContactName,
      siteContactNo: projectDataForUpdate.secondaryMobile || projectDataForUpdate.siteContactNo
    };

    console.log("Mapped backend data:", backendProjectData);
  
      // Update project data without numBlocks
      const apiUrl = `${process.env.REACT_APP_FORE_APILINK}/projects/update-project?projectId=${projectId}`;
      console.log("Updating project at URL:", apiUrl);
      
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify(projectDataForUpdate)
      });
  
      const data = await response.json();
      console.log("Update response:", data);
      
      if (!response.ok) {
        throw new Error(data.error || data.message || 'Failed to update project data');
      }
  
      // Step 2: Check if blocks already exist
      let shouldCreateBlock = false;
      try {
        const blocksCheckUrl = `${process.env.REACT_APP_FORE_APILINK}/blocks/get-all-blocks-of-project?projectId=${projectId}`;
        const blocksResponse = await fetch(blocksCheckUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
        
        const blocksData = await blocksResponse.json();
        const existingBlocks = Array.isArray(blocksData) ? blocksData : (blocksData.data || []);
        
        // Filter out empty blocks
        const validBlocks = existingBlocks.filter(block => 
          block.blockNo && block.blockNo.trim() !== '' && 
          block.numFloors && block.numFloors > 0 && 
          block.numFlatsPerFloor && block.numFlatsPerFloor > 0
        );
        
        // Only create a block if no valid blocks exist
        shouldCreateBlock = validBlocks.length === 0;
        
        // Delete any empty blocks
        for (const block of existingBlocks) {
          if (!block.blockNo || block.blockNo.trim() === '' || 
              !block.numFloors || block.numFloors <= 0 || 
              !block.numFlatsPerFloor || block.numFlatsPerFloor <= 0) {
            
            console.log("Deleting empty block:", block._id);
            const deleteUrl = `${process.env.REACT_APP_FORE_APILINK}/blocks/delete-block?blockId=${block._id}`;
            await fetch(deleteUrl, {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json',
                'x-token': token
              }
            });
          }
        }
        
      } catch (error) {
        console.error("Error checking existing blocks:", error);
        // Default to creating a block if we can't check
        shouldCreateBlock = true;
      }
  
      // Step 3: Create block if needed
      if (shouldCreateBlock && 
          projectData.numFloors && 
          projectData.numFlatsPerFloor && 
          parseInt(projectData.numFloors) > 0 && 
          parseInt(projectData.numFlatsPerFloor) > 0) {
        try {
          await createBlock(token);
          console.log("Block created successfully");
        } catch (blockError) {
          console.error("Error creating block:", blockError);
          // Continue even if block creation fails
        }
      } else {
        console.log("Skipping block creation - valid blocks already exist or invalid data");
      }
  
      // Step 4: Now update the project with numBlocks after we've handled blocks
      if (numBlocksValue) {
        const finalUpdateUrl = `${process.env.REACT_APP_FORE_APILINK}/projects/update-project?projectId=${projectId}`;
        const finalUpdateResponse = await fetch(finalUpdateUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          },
          body: JSON.stringify({ numBlocks: numBlocksValue })
        });
        
        const finalUpdateData = await finalUpdateResponse.json();
        console.log("Final update with numBlocks response:", finalUpdateData);
      }
  
      // alert('Project updated successfully');
      setIsSaving(false);
      navigate('/consumer/projects', { 
        state: { 
          projectId: projectId,
          customer_id: data.customer_id,
        } 
      });
      console.log("projectId", projectId);
      console.log("customer_id", data.customer_id);
       } catch (error) {
      console.error('Error updating project data:', error);
      setError(error.message || 'Failed to update project data');
      setIsSaving(false);
    }
  };
 const getCustomerDetails = async (customerId) => {
        if (!customerId) {
            console.error("Customer ID is required");
            setError("Customer ID is required");
            setLoading(false);
            return;
        }
        setLoading(true);
        const userData = JSON.parse(localStorage.getItem('userData'));
        const token = userData?.token || sessionStorage.getItem('token');
        try {
            const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/get-customer-by-customerId?customer_id=${customerId}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-token': token
                }
            });
            if (!response.ok) {
                throw new Error('Failed to fetch customer data');
            }
            const result = await response.json();
            console.log('Customer data fetched:', result);
            if (result.success) {
                setCustomerData(result.data);
            } else {
                console.error('Failed to fetch customer:', result.message);
            }
        } catch (error) {
            console.error('Error:', error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Preview image
      const reader = new FileReader();
      reader.onload = (ev) => {
        setProjectImage(ev.target.result);
      };
      reader.readAsDataURL(file);

    }
  };

 return (
  <div className="bg-gray-50 min-h-screen pb-4">
    {/* Header */}
    <div className="w-full px-2 py-4 sticky top-0 z-10 border-b border-gray-200 bg-white">
      <div className="flex items-center">
        <img
          src={ArrowLeft}
          className="w-10 h-6 text-gray-600 mr-1 cursor-pointer"
          onClick={() => navigate(-1)}
        />
        <h1 className="text-[#0D0C0C] font-medium text-md">Project</h1>
      </div>
    </div>

    {/* Loading */}
    {loading && (
      <div className="flex justify-center items-center h-40">
        <p className="text-gray-600">Loading project data...</p>
      </div>
    )}

    {/* Error */}
    {error && (
      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mx-4 my-4 text-sm">
        {error}
      </div>
    )}

    {!loading && !error && (
      <>
        {/* Project Summary */}
<div className="bg-white mx-4 mt-4 p-4 rounded-lg shadow-sm flex items-center space-x-4">
  {/* Small circular image on left */}
  <div 
    className="w-14 h-14 bg-[#F9F5F5] rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden cursor-pointer hover:opacity-80 transition-opacity"
    onClick={() => {
      // Only show preview if there's an actual project image (not fallback)
      const hasProjectImage = (Array.isArray(projectImage) && projectImage.length > 0) || 
                             (typeof projectImage === 'string' && projectImage && projectImage !== Buildingimage);
      if (hasProjectImage) {
        setShowImagePreview(true);
      }
    }}
  >
    <img
      src={
        Array.isArray(projectImage) && projectImage.length > 0
          ? `${process.env.REACT_APP_FORE_MEASURIT_UIIMAGEURL}${projectImage[0]}`
          : typeof projectImage === 'string' && projectImage
          ? projectImage
          : Buildingimage
      }
      alt="Project"
      className="w-12 h-12 object-cover rounded-full"
      onError={(e) => {
        console.error("Image failed to load, using fallback");
        e.target.onerror = null;
        e.target.src = Buildingimage;
      }}
    />
  </div>

  <div className="flex-1">
    <h2 className="text-lg font-semibold text-[#000000]">{projectData.projectName || "Project Name"}</h2>
    <p className="text-sm text-[#000000] whitespace-pre-wrap break-words">
      {(projectData.siteAddress?.length > 50) 
        ? `${projectData.siteAddress?.substring(0, 50)}...`
        : (projectData.siteAddress || "Location not specified")
      }
    </p>
  </div>
</div>

{/* Image Preview Modal */}
{showImagePreview && (
  <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-start justify-center p-4 pt-10">
    {/* Close button */}
    <button
      onClick={() => setShowImagePreview(false)}
      className="absolute top-4 right-4 w-10 h-10 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all z-60"
    >
      ×
    </button>
    
    {/* Image container */}
    <div className="relative max-w-full max-h-full mt-10">
      <img
        src={
          Array.isArray(projectImage) && projectImage.length > 0
            ? `${process.env.REACT_APP_FORE_MEASURIT_UIIMAGEURL}${projectImage[0]}`
            : typeof projectImage === 'string' && projectImage
            ? projectImage
            : Buildingimage
        }
        alt="Project Preview"
        className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
        onClick={() => setShowImagePreview(false)}
      />
      
      {/* Image info */}
      <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-3 rounded-b-lg">
        <p className="text-sm font-medium">{projectData.projectName || "Project Image"}</p>
      </div>
    </div>
    
    {/* Backdrop click to close */}
    <div 
      className="absolute inset-0 -z-10" 
      onClick={() => setShowImagePreview(false)}
    ></div>
  </div>
)}



        {/* Project Details Section */}
        <div className="bg-white mx-4 mt-4 p-4 rounded-lg shadow-sm py-4">
          {/* Section header with icon */}
          <div className="flex items-center mb-4">
            <div className="w-8 h-8 bg-[#F6FAFD] rounded-full flex items-center justify-center mr-2">
              <img
                src={GrayBuilding}
                alt="Building"
                className="w-4 h-4 object-contain"
              />
            </div>
            <h2 className="text-sm font-medium text-[#000000]">Project Details</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-4">
              <div>
                <label htmlFor="projectName" className="text-xs font-medium text-[#BBB4B4] mb-1 block">Name of Projet</label>
                <input
                  id="projectName"
                  name="projectName"
                  type="text"
                  required
                  value={projectData.projectName}
                  onChange={handleInputChange}
                  className="block w-full h-12 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:border-gray-300"
                  placeholder="Enter project name"
                />
              </div>
<div className="relative">
  <label htmlFor="projectStage" className="text-xs font-medium text-[#BBB4B4] mb-1 block">
    Stage of Construction
  </label>
  
  {/* Custom Dropdown Button */}
  <div
    className="block w-full h-12 px-3 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:border-gray-300 cursor-pointer flex items-center justify-between"
    onClick={() => setShowStageDropdown(!showStageDropdown)}
  >
    <span className={projectData.projectStage ? "text-gray-900" : "text-gray-400"}>
      {projectData.projectStage || "Select Stage"}
    </span>
    <svg 
      className={`w-4 h-4 text-gray-400 transition-transform ${showStageDropdown ? 'rotate-180' : ''}`} 
      fill="none" 
      stroke="currentColor" 
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  </div>

  {/* Custom Dropdown Options */}
  {showStageDropdown && (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 z-40" 
        onClick={() => setShowStageDropdown(false)}
      ></div>
      
      {/* Dropdown Menu */}
   <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-50 max-h-60 overflow-y-auto">
{stages.map((stage, index) => (
  <div
    key={index}
    className={`px-4 py-1 hover:bg-gray-50 cursor-pointer transition-colors ${
      projectData.projectStage === stage.value ? 'bg-[#F5F5F5] text-gray-900' : 'text-gray-700'
    }`}
    onClick={() => {
      handleInputChange({
        target: { name: 'projectStage', value: stage.value }
      });
      setShowStageDropdown(false);
    }}
  >
    <span className="text-sm">{stage.label}</span>
  </div>
))}

</div>

    </>
  )}
</div>


            <div>
    <label htmlFor="siteAddress" className="text-xs font-medium text-[#BBB4B4] mb-1 block focus:outline-none focus:border-gray-300">Location</label>
    <div className="relative">
        <input
            id="siteAddress"
            name="siteAddress"
            type="text"
            required
            value={projectData.siteAddress}
            onChange={handleInputChange}
            className="block w-full h-12 px-3 py-2 pr-12 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:border-gray-300"
            placeholder="Enter location"
        />
        <div className="absolute inset-y-0 right-0 flex items-center pr-3">
            <img src={Map} alt="Map" className="h-5 w-5 object-contain" />
        </div>
    </div>
</div>


     <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
  <div className="relative">
    <label className="block text-xs font-medium text-[#BBB4B4] mb-1">Project Type</label>
    
    {/* Custom Dropdown Button */}
    <div
      className="w-full h-12 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:border-gray-300 cursor-pointer flex items-center justify-between"
      onClick={() => setShowProjectTypeDropdown(!showProjectTypeDropdown)}
    >
     <span className={projectData.project_type ? "text-gray-900" : "text-gray-400"}>
  {projectData.project_type || "Select projectType"} 
</span>
      <svg 
        className={`w-4 h-4 text-gray-400 transition-transform ${showProjectTypeDropdown ? 'rotate-180' : ''}`} 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </div>

    {/* Custom Dropdown Options */}
    {showProjectTypeDropdown && (
      <>
        {/* Backdrop */}
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setShowProjectTypeDropdown(false)}
        ></div>
        
        {/* Dropdown Menu */}
        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-50 max-h-60 overflow-y-auto">
          {[
            { value: "Flat", label: "Flat" },
            { value: "Villa", label: "Villa" }
          ].map((option, index) => (
            <div
              key={index}
            // Around line 470-480, in the dropdown options
className={`px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors ${
  projectData.project_type === option.value ? 'bg-[#F5F5F5] text-gray-900' : 'text-gray-700' // Changed from projectType
}`}

              onClick={() => {
                handleInputChange({
                  target: {
                      name: 'project_type',
                    value: option.value
                  }
                });
                setShowProjectTypeDropdown(false);
              }}
            >
              <span className="text-sm">{option.label}</span>
            </div>
          ))}
        </div>
      </>
    )}
  </div>

  <div>
    <label className="block text-xs font-medium text-[#BBB4B4] mb-1">No of Units</label>
    <input
      type="number"
      name="numFloors"
      value={projectData.numFloors}
      onChange={handleInputChange}
      className="w-full h-12 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:border-gray-300"
      placeholder="e.g. 5"
      required
    />
  </div>

  {/* Hide "No of Floors" only when Project Type is "Villa" */}
  {projectData.projectType !== "Villa" && (
    <div>
      <label className="block text-xs font-medium text-[#BBB4B4] mb-1">No of Floors</label>
      <input
        type="number"
        name="numFlatsPerFloor"
        value={projectData.numFlatsPerFloor}
        onChange={handleInputChange}
        min="1"
        className="w-full h-12 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:border-gray-300"
        placeholder="e.g. 4"
        required
      />
    </div>
  )}
</div>

</div>

          </form>
      

        {/* Contact Information Section */}
          <div className="flex items-center mb-4 mt-6">
            <div className="w-8 h-8 bg-[#F6FAFD] rounded-full flex items-center justify-center mr-2">
              <img
                src={Contact}
                alt="Contact"
                className="w-4 h-4 object-contain"
              />
            </div>
            <h2 className="text-sm font-medium text-[#000000]">Contact Details</h2>
          </div>

          <h3 className="text-xs  font-medium text-[#000000] mb-2">Primary Contact (Owner/Builder)</h3>
         <div className="space-y-4 mb-6">
 <div>
  <label htmlFor="builderName" className="text-xs font-medium text-[#BBB4B4] mb-1 block">Name</label>
  <input
    id="builderName"
    type="text"
    name="builderName"
    value={projectData.builderName || customerData?.customer_name || ''}
    onChange={handleInputChange}
    className="w-full h-12 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:border-gray-300"
    placeholder="Enter name"
    required
  />
</div>
      <div>
  <label htmlFor="builderContactNo" className="text-xs font-medium text-[#BBB4B4] mb-1 block">Mobile Number</label>
  <input
    id="builderContactNo"
    type="tel"
    name="builderContactNo"
    value={projectData.builderContactNo || customerData?.mobile_number || ''}
    onChange={handleInputChange}
    className="w-full h-12 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:border-gray-300"
    placeholder="Enter mobile number"
    required
  />
</div>
          </div>
       <div className="flex-1 border-t border-gray-300"></div>
<h3 className="text-xs font-medium text-[#000000] mb-2 mt-4">Secondary Contact (Supervisor/Other)</h3>
<div className="space-y-4">
  <div>
    <label htmlFor="siteContactName" className="text-xs font-medium text-[#BBB4B4] mb-1 block">Name</label>
    <input
      id="siteContactName"
      type="text"
      name="siteContactName"
      value={projectData.siteContactName || ''}
      onChange={handleInputChange}
      className="w-full h-12 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:border-gray-300"
      placeholder="Enter name"
    />
  </div>
  <div>
    <label htmlFor="siteContactNo" className="text-xs font-medium text-[#BBB4B4] mb-1 block">Mobile Number</label>
    <input
      id="siteContactNo"
      type="tel"
      name="siteContactNo"
      value={projectData.siteContactNo || ''}
      onChange={handleInputChange}
      className="w-full h-12 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm block focus:outline-none focus:border-gray-300"
      placeholder="Enter mobile number"
    />
  </div>
</div>

        
        </div>

        {/* Submit Button Fixed */}
        <div className="fixed bottom-0 left-0 right-0 bg-white p-4 border-t border-gray-200 shadow-sm">
          <button
            type="submit"
            onClick={handleSubmit}
            className="w-full py-3 bg-[#D93025] text-white text-base rounded-md font-semibold hover:bg-[#c22820] transition"
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        </div>

        {/* Spacer */}
        <div className="h-20"></div>
      </>
    )}
  </div>
);



};

export default ViewProject;
